import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';
import { SquareArrowRight } from 'lucide-react';
import { BsLinkedin } from "react-icons/bs";

const AdvisoryBoardCarousel = ({ members }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiperInstance = swiperRef.current.swiper;
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, []);


  return (
    <div className="w-full">
      <div className="">
        {/* Heading */}
        <div className="text-center md:text-center mb-10 md:mb-12">
          <h2 className="font-[600] text-[#111827] -tracking-[1.1px] text-[40px] leading-[44px]">
            Our Team
          </h2>
        </div>

        {/* Swiper Carousel with Navigation */}
        <div className="relative advisory-carousel [&_.swiper-pagination]:!static [&_.swiper-pagination]:!mt-6 [--swiper-pagination-bullet-size:10px]">
          <Swiper
            ref={swiperRef}
            modules={[Navigation, Pagination, Autoplay]}
            loop={true}
            slidesPerView={1}
            spaceBetween={30}
            pagination={{clickable : true}}
            breakpoints={{
              768: { slidesPerView: 3, spaceBetween: 30 },
              1024: { slidesPerView: 4, spaceBetween: 30 },
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            autoplay={{
              delay: 4000,
            }}
            className="relative h-full"
          >
            <div>
              {members.map((member, index) => (
                <SwiperSlide key={index}>
                  <article className="duration-300 flex flex-col items-center bg-white rounded-[10px] h-full">
                    <figure className="overflow-hidden relative w-full transition-[height] duration-[1s] ease-in-out h-64 min-[464px]:max-[768px]:h-[500px]">
                      <img
                        src={member.img}
                        alt={member.name}
                        className=" w-full h-full object-cover absolute top-0 left-0"
                      />
                    </figure>
                    <figcaption className="flex flex-col items-center gap-y-3 px-4 py-8">
                      <div className="flex items-center justify-center gap-x-3">
                        <h3 className="font-[600] text-center text-[#000000] leading-[30px] text-[20px]">{member.name}</h3>
                        <a href={member.link} target='_blank'>
                          <BsLinkedin className="text-[#2867b2]" />
                        </a>
                      </div>
                      <h5 className="font-[600] text-[#58595B] text-center text-[15px] leading-[24px]">{member.position}</h5>
                    </figcaption>
                    <div className="text-center hidden">
                      <div className="flex justify-center md:justify-between items-center">
                        <div className="text-center md:text-start">
                          <h3 className="text-lg text-center md:text-xl font-semibold text-gray-800 mb-1">{member.name}</h3>
                          <p className="text-sm text-gray-600">{member.position}</p>
                        </div>
                        <div className="text-end md:ml-8 hidden md:block">
                          <a
                            href={member.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className=""
                          >
                            <img
                              src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
                              alt="LinkedIn"
                              className="w-6 h-6"
                            />
                          </a>
                        </div>
                      </div>
                      <div className="md:hidden flex justify-center mt-2"> {/* Mobile LinkedIn icon */}
                        <a
                          href={member.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
                            alt="LinkedIn"
                            className="w-6 h-6"
                          />
                        </a>
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              ))}
            </div>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default AdvisoryBoardCarousel;